import { render, staticRenderFns } from "./FullLayout.vue?vue&type=template&id=0d272aa4&scoped=true&"
import script from "./FullLayout.vue?vue&type=script&lang=js&"
export * from "./FullLayout.vue?vue&type=script&lang=js&"
import style0 from "./FullLayout.vue?vue&type=style&index=0&id=0d272aa4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d272aa4",
  null
  
)

export default component.exports